import { render, staticRenderFns } from "./SelfMonitoringReportsView.vue?vue&type=template&id=3aa87f0b&scoped=true"
import script from "./SelfMonitoringReportsView.vue?vue&type=script&lang=ts"
export * from "./SelfMonitoringReportsView.vue?vue&type=script&lang=ts"
import style0 from "./SelfMonitoringReportsView.vue?vue&type=style&index=0&id=3aa87f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa87f0b",
  null
  
)

export default component.exports